<template>
  <el-container type="flex" class="main_container">
    <base-header>商品销售排行</base-header>
    <el-main>
      <div style="padding: 10px 0 0 20px;">
        <span style="margin-right: 20px;">选择种类</span>
        <el-select v-model="type" placeholder="选择种类">
          <el-option label="全部团购" :value="1" />
          <el-option label="自主发布团购" :value="0" />
          <el-option label="品牌商商品" :value="2" />
          <el-option label="团小蜜团长售卖" :value="3" />
          <el-option label="团小蜜整体数据" :value="4" />
        </el-select>
        <el-popover trigger="hover" :content="typeInfo" style="margin-right: 20px;" placement="right">
          <i class="el-icon-question" slot="reference" />
        </el-popover>
      </div>
      <div style="padding: 10px 0 0 20px;">
        <span style="margin-right: 20px;">选择时间（带快捷选项）</span>
        <el-date-picker
          v-model="selectTime"
          type="datetimerange"
          range-separator="至"
          style="margin-right: 20px;"
          :picker-options="pickerOptions"
          :disabled="allTime"
          start-placeholder="开始时间"
          end-placeholder="结束时间">
        </el-date-picker>
        <el-checkbox v-model="allTime" style="margin-left: 20px;">全部时间</el-checkbox>
      </div>
      <div style="padding: 10px 0 0 20px;">
        <span style="margin-right: 20px;">排行依据</span>
        <el-select v-model="sort" placeholder="请选择">
          <el-option label="销售金额" value="income" />
          <el-option label="销售数量" value="total" />
        </el-select>
      </div>
      <div style="padding: 10px 0 0 20px;">
        <el-button type="primary" @click="getList">开始排行</el-button>
      </div>
      <el-table
        :data="list"
        v-loading="loading"
        style="padding: 30px 0 0 20px;"
      >
        <el-table-column label="名称图片">
          <template v-slot="scope">
            <div style="display: flex; align-items: center;">
              <img v-if="scope.row.goods_pic" :src=scope.row.goods_pic>
              {{scope.row.goods_name}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="create_time" align="center">
        </el-table-column>
        <el-table-column label="销售金额（元）" prop="income" align="center">
        </el-table-column>
        <el-table-column label="销售量" prop="total" align="center">
        </el-table-column>
        <el-table-column label="团长/品牌商昵称头像">
          <template v-slot="scope">
            <div style="display: flex; align-items: center;">
              <img v-if="scope.row.avatar_url" :src=scope.row.avatar_url>
              {{scope.row.nickname}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="团长/品牌商id" prop="client_id" align="center">
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer">
      <el-pagination
        :total="totalCount"
        :page-size="pagesize"
        :current-page="page"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      />
    </el-footer>
  </el-container>
</template>

<script>
import pageMixin from '../../../mixins/page'

export default {
  name: 'GoodsRank',
  mixins: [pageMixin],
  data () {
    return {
      list: [],
      selectTime: [],
      allTime: true,
      type: 1,
      sort: 'income',
      pickerOptions: {
        shortcuts: [
          {
            text: '今日',
            onClick (picker) {
              const end = new Date()
              const start = new Date(new Date().toLocaleDateString())
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '昨日',
            onClick (picker) {
              const end = new Date(new Date().toLocaleDateString())
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  computed: {
    typeInfo () {
      if (this.type === 0) {
        return '团购的排行，不包括上品牌商的货的'
      } else if (this.type === 1) {
        return '所有团购的排行，包含自主发布与上品牌商的货的'
      } else if (this.type === 2) {
        return '品牌商所发的能透传的商品的排行，包含下级代销'
      } else {
        return '暂无说明'
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      let start
      let end
      if (!this.allTime && this.selectTime && this.selectTime[0] && this.selectTime[1]) {
        start = Math.round(this.selectTime[0].getTime() / 1000)
        end = Math.round(this.selectTime[1].getTime() / 1000)
      }
      this.loading = true
      const params = {
        type: this.type,
        page: this.page,
        pagesize: this.pagesize,
        start_time: start,
        end_time: end,
        sort: this.sort
      }
      const handle = res => {
        res.data.content.order_data.forEach(item => {
          item.income = (item.income / 100).toFixed(2)
          item.create_time = this.timeTransform(item.create_time)
        })
        this.list = res.data.content.order_data
        this.totalCount = res.data.content.total
      }
      const loading = () => {
        this.loading = false
      }
      this.__axios(this.getDomain() + 'bmsummary/income_rank', params, handle, loading)
    }
  }
}
</script>

<style scoped>
  img {
    width: 30px;
    height: 30px;
  }
</style>
